'use strict';

require('core/warranty');
